/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TellerCombinedReportResponseDto { 
    accountNumber?: string | null;
    tellerName?: string | null;
    user?: string | null;
    withdrawalAmount?: number;
    depositeAmount?: number;
    balance?: number;
    userId?: number;
    accountId?: number;
}

